export interface CustomGapSizeOptionProps {
  gapSize: number;
  className?: string;
  onUpdateGapSize(gapSize: number, undoable?: boolean): void;
}

export const CUSTOM_GAP_MIN_SIZE = 10;
export const CUSTOM_GAP_MAX_SIZE = 100;
